import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from '../LoadingSpinner';
import './Operations.css';

function InventoryView() {
  const { sku } = useParams();
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    fetchInventory();
  }, [sku]);

  const fetchInventory = async () => {
    try {
      const response = await axios.get(`/api/ops/inventory/${sku}`);
      setInventory(response.data);
      const total = response.data.reduce((sum, item) => sum + item.quantity, 0);
      setTotalQuantity(total);
    } catch (error) {
      console.error('Failed to fetch inventory:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="ops-page">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="ops-page">
      <div className="ops-page-header">
        <Link to={`/ops/${sku}`} className="back-button">← Back</Link>
        <h1>Inventory for {sku}</h1>
        <div className="total-qty">Total: {totalQuantity} units</div>
      </div>

      <div className="inventory-list">
        {inventory.length === 0 ? (
          <div className="no-data">No inventory found for this SKU</div>
        ) : (
          inventory.map((item, index) => (
            <div key={index} className="inventory-item">
              <div className="bin-code">{item.bin_code}</div>
              <div className="bin-details">
                <div className="bin-location">
                  Zone {item.zone} | Aisle {item.aisle} | Shelf {item.shelf}
                </div>
                <div className="bin-quantity">
                  <span className="qty-label">Quantity:</span>
                  <span className="qty-value">{item.quantity}</span>
                </div>
                {item.lot_number && (
                  <div className="lot-info">Lot: {item.lot_number}</div>
                )}
                {item.last_counted && (
                  <div className="last-counted">
                    Last counted: {new Date(item.last_counted).toLocaleDateString()}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default InventoryView;